const minWidths = {
    xs: 0,
    sm: 321,
    md: 481,
    lg: 769,
    xl: 1024,
    xxl: 1281,
};

const screenSize = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    XXL: 'xxl',
};

const screenType = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

const constellationBrowserUtils = {
    minWidths,
    screenSize,
    screenType,
    removeElementById(id) {
        const elem = document.getElementById(id);

        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    },
    screen: {
        width() {
            if (typeof window !== 'undefined') {
                return window.innerWidth && document.documentElement.clientWidth ?
                    Math.min(window.innerWidth, document.documentElement.clientWidth) :
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth;
            }
            return null;
        },
        size(width = screen.width()) {
            if (width < minWidths.sm) {
                return screenSize.XS;
            }
            if (width < minWidths.md) {
                return screenSize.SM;
            }
            if (width < minWidths.lg) {
                return screenSize.MD;
            }
            if (width < minWidths.xl) {
                return screenSize.LG;
            }
            if (width < minWidths.xl) {
                return screenSize.XL;
            }
            if (width >= minWidths.xxl) {
                return screenSize.XXL;
            }
            return null;
        },
        type(size = screen.size()) {
            switch (size) {
                case screenSize.XS:
                case screenSize.SM:
                    return screenType.MOBILE;
                case screenSize.MD:
                case screenSize.LG:
                    return screenType.TABLET;
                case screenSize.XL:
                case screenSize.XXL:
                    return screenType.DESKTOP;
                default:
                    return null;
            }
        },
    },
};

constellationBrowserUtils.screen.width = constellationBrowserUtils.screen.width.bind(constellationBrowserUtils);
constellationBrowserUtils.screen.size = constellationBrowserUtils.screen.size.bind(constellationBrowserUtils);
constellationBrowserUtils.screen.type = constellationBrowserUtils.screen.type.bind(constellationBrowserUtils);

export default constellationBrowserUtils;
